import { useMemo } from 'react';

import { buildNameChangeText, findOldName, OldNameControllingSubjectType } from '../common/knmNameChangeUtils';
import { IOldNameControllingSubject } from '../../../APIPackage/KnmModule/interfaces/IOldNameControllingSubject';

interface IUseControllingSubjectNameChangeTextParams {
  type: OldNameControllingSubjectType;
  guid: string | null | undefined;
  currentName: string | null | undefined;
  // Количество КЛ/ОБК
  currentCount?: number;
  enabled?: boolean;
  oldNames: IOldNameControllingSubject[] | null | undefined;
  changeDate: string | null | undefined;
}

export const useControllingSubjectNameChangeText = ({
  type,
  guid,
  currentName,
  currentCount,
  enabled = true,
  oldNames,
  changeDate,
}: IUseControllingSubjectNameChangeTextParams): string | null => {
  return useMemo(() => {
    if (!enabled) {
      return null;
    }

    const match = findOldName({ oldNames, type, guid, currentCount });

    return match ? buildNameChangeText(match.name, currentName, match.date ?? changeDate) : null;
  }, [enabled, oldNames, type, guid, currentCount, changeDate, currentName]);
};

export const useKnoNameChangeText = (
  currentName: string | null | undefined,
  oldKnoOrganization: string | null | undefined,
  dateReasonChangeKno: string | null | undefined,
): string | null => {
  return useMemo(() => buildNameChangeText(oldKnoOrganization, currentName, dateReasonChangeKno), [
    oldKnoOrganization,
    currentName,
    dateReasonChangeKno,
  ]);
};
